<button type="button" role="switch" class="ia-switch"
        [attr.aria-checked]="encendido" [attr.aria-label]="etiqueta || null"
        [attr.aria-busy]="ocupado || null" [title]="etiqueta"
        [class.ia-switch-on]="encendido" [class.ia-switch-ocupado]="ocupado"
        [disabled]="deshabilitado" (click)="tocar($event)" (keydown)="$event.stopPropagation()">
  <span class="ia-switch-bolita" aria-hidden="true"></span>
</button>
